import axios from "axios";

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers:{
        Authorization: ''
    }
})

const endpoint = 'web'

const webRequest = {
    getServices(){
        return api.get(`/${endpoint}/get_all_services`)
    },
}

export default webRequest;
